import React from 'react';
import DesignTwentyOne from '../components/PageBuilder/sections/DesignTwentyOne';

const EventDetailPage = () => {
    return <DesignTwentyOne />;
};

export default EventDetailPage;
